;
(function (factory) {
    "use strict";

    if (typeof define === "function" && define.amd) {
        define(factory);
    } else if (typeof module != "undefined" && typeof module.exports != "undefined") {
        module.exports = factory();
    } else {
        /* jshint sub:true */
        window["Spinner"] = factory();
    }
}(function () {
    "use strict";

    function Spinner(element, options) {
        this.options = options || {};
        this.initialize.apply(this, arguments);
    }

    var counter = 0;

    Spinner.prototype = {
        animating: false,

        counter_: 0,

        template: '<div class="spinner-wrp">\
                <div class="spinner-item"></div>\
                <div class="spinner-item"></div>\
                <div class="spinner-item"></div>\
                <div class="spinner-item"></div>\
            </div>',

        initialize: function (element, options) {
            this.options = options || {};
            this.element = element || document.body;
            this.counter_ = 0;

            this.render();
        },

        render: function () {
            this.spinner = document.createElement('div');

            this.spinner.innerHTML = this.template;
            this.spinner.className = 'spinner';
            this.spinner.id = 'spinner';

            this.element.appendChild(this.spinner);
        },

        start: function () {
            this.spinner.classList.add('spinner-start');
            this.animating = true;
            ++this.counter_;

            return this;
        },

        stop: function () {
            --this.counter_;
            if (this.counter_ < 0) {
                this.counter_ = 0;
            }

            if (!this.counter_) {
                this.spinner.classList.remove('spinner-start');
                this.animating = false;
            }

            return this;
        },

        isActive: function () {
            return this.animating;
        },

        destroy: function () {
            this.spinner.remove();
        }
    };

    Spinner.create = function (element, options) {
        return new Spinner(element, options);
    };

    return Spinner;
}));
